import React from "react"

export default function Title({ className }: { className?: string }) {
  return <span className={className}>Codé avec ❤️ et React.JS</span>
}
